import copy from "copy-to-clipboard";
import $ from "jquery";
import { handleSaveComponent } from "../editor/component-blocks";
import { setTempStateLocalStorage } from "../local-store";

function copyToClipboard(data = []) {
  // Skip any empty datatype
  if (!data.length) {
    return;
  }

  // Filter out empty data
  data = data.filter((d) => d?.data);

  // Skip any empty datatype
  if (!data.length) {
    return;
  }

  // Copy first element and reset inside onCopy
  var text = data[0].data;
  var format = data[0].format;

  copy(text, {
    format: format,
    onCopy: (clipboardData) => {
      // Loop after first element and add to clipboard
      for (let i = 1; i < data.length; i++) {
        text = data[i].data;
        format = data[i].format;
        clipboardData.setData(format, text);
      }

      return true;
    },
  });
}

export default function rawCopyHandler(event, actions, query, document) {
  const selectedNodes = query.getEvent("selected");

  // Ignore the child nodes from selected nodes to avoid duplicate child nodes
  var nodeHasParents = selectedNodes
    .all()
    .reduce((o, key) => Object.assign(o, { [key]: false }), {});
  selectedNodes.all().forEach((selectedNode) => {
    const parents = query.node(selectedNode).ancestors();
    if (selectedNodes.all().some((r) => parents.indexOf(r) >= 0)) {
      // Parent is already present in selectedNodes
      nodeHasParents[selectedNode] = true;
    }
  });

  // To store JSON Stringified Node Trees
  var nodeTrees = [];
  var blocksText = "",
    blocksHTML = "";

  selectedNodes.all().forEach((selectedNode) => {
    // Skip if parent is already being added
    if (nodeHasParents[selectedNode]) {
      return;
    }

    nodeTrees.push(handleSaveComponent(selectedNode, query));
    let selectedNodeDOM = $(
      document.querySelector(`[data-grigora-block-id="${selectedNode}"`),
    );
    blocksText += selectedNodeDOM.clone().find("style").remove().end().text();
    blocksHTML += selectedNodeDOM.html();
  });

  // var commonAncestorContainer = allParents.first();

  copyToClipboard([
    {
      format: "text/plain",
      data: blocksText,
    },
    {
      format: "text/html",
      data: blocksHTML,
    },
    {
      format: "grigora/blocks",
      data: JSON.stringify(nodeTrees),
    },
  ]);

  // Also set localstorage for the copied blocks
  setTempStateLocalStorage("copiedBlocks", nodeTrees);

  return;
}
